import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Calendrier générique (hors nav) — duotone */
export const CalendarIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* En-tête menthe */}
      <path
        d="M3.5 7.5V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v1.5h-17z"
        fill="var(--equiply-icon-bg)"
      />
      {/* Corps */}
      <rect x="3.5" y="4" width="17" height="16.5" rx="2" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <path d="M3.5 9h17" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 3v3M16 3v3" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Point central */}
      <circle cx="12" cy="14.5" r="1.25" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
CalendarIcon.displayName = "CalendarIcon";
